import { render, staticRenderFns } from "./PriceAdjustmentProductAdder.vue?vue&type=template&id=457dc086"
import script from "./PriceAdjustmentProductAdder.vue?vue&type=script&lang=js"
export * from "./PriceAdjustmentProductAdder.vue?vue&type=script&lang=js"
import style0 from "./PriceAdjustmentProductAdder.vue?vue&type=style&index=0&id=457dc086&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports